import cx from 'classnames';

import Checkbox from 'components/common/checkbox/checkbox';
import InputBalance from './input-balance';
import { TableHead } from './retire-table-elements';

import { formatTokenAmount } from 'utils/amounts';

import {
  StyledTableWrapper,
  StyledTableBody,
  StyledTableRows,
  StyledTableRow,
  StyledTableCell,
  StyledEmpty
} from './retire-table.style';

import { TokenProjectType } from 'types';

const RetireTable = ({
  mode = 'default',
  data = [],
  selected,
  handleChange,
  handleSelect,
  mb
}: {
  mode?: 'default' | 'input' | 'selected';
  data?: TokenProjectType[];
  selected: TokenProjectType[];
  handleChange?: (project_id: string, value: string) => void;
  handleSelect?: (row: TokenProjectType) => void;
  mb?: string;
}) => {
  const projects = data.length > 0 ? data : selected;

  const isSelected = (project_id: string) =>
    selected.some((el) => el.project_id === project_id);

  if (projects.length === 0) {
    return (
      <StyledEmpty mb={mb}>
        <p>Empty</p>
      </StyledEmpty>
    );
  }

  return (
    <StyledTableWrapper mb={mb}>
      <TableHead className={mode} />
      <StyledTableBody>
        <StyledTableRows>
          {projects.map((row: TokenProjectType) => {
            const { project_id, name, balance } = row;
            const isItemSelected = isSelected(project_id);
            return (
              <StyledTableRow
                key={project_id}
                className={cx(`mode-${mode}`, {
                  'is--checked': isItemSelected
                })}
              >
                <StyledTableCell>{name}</StyledTableCell>
                <StyledTableCell>
                  {formatTokenAmount(balance, 24, 5)} OCC
                </StyledTableCell>

                {mode !== 'default' && (
                  <StyledTableCell>
                    {isItemSelected && (
                      <InputBalance
                        selected={selected}
                        handleChange={handleChange}
                        row={row}
                      />
                    )}
                  </StyledTableCell>
                )}

                {mode !== 'selected' && (
                  <StyledTableCell>
                    <Checkbox
                      checked={isItemSelected}
                      type="middle"
                      onChange={() => handleSelect(row)}
                    />
                  </StyledTableCell>
                )}
              </StyledTableRow>
            );
          })}
        </StyledTableRows>
      </StyledTableBody>
    </StyledTableWrapper>
  );
};

export default RetireTable;
